import { Grid, List, ListItem, ListItemText } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useGetDataQuery } from '../../api/apiSlice';
import ExternalScreen from '../../components/fragments/ExternalScreen';

export default function ScreenMyInformation() {
    const state = useSelector((st) => st);

    const { data: { data } = {}, isFetching } = useGetDataQuery({
        list: `/pastor/${state?.auth?.user?.username}`,
    });

    const { about, analytics: { follows, devotions } = {} } = data || {};

    const {
        user: {
            username,
            firstName,
            surname,
            gender,
            estate,
            date_of_birth,
            contact: { phoneNumber, email } = {},
        } = {},
    } = state.auth;

    const userData = [
        { label: 'Name', value: `${firstName} ${surname}` },
        { label: 'Username', value: username },
        { label: 'Follows', value: follows || 0 },
        { label: 'Devotions', value: devotions || 0 },
        { label: 'Gender', value: gender },
        { label: 'Date of Birth', value: date_of_birth },
        { label: 'Email Address', value: email },
        { label: 'Phone Number', value: phoneNumber },
        { label: 'Area of Service', value: estate },
        { label: 'Bio', value: about },
    ];

    return (
        <ExternalScreen loading={isFetching} title="My Information">
            <Grid xs={12}>
                <List>
                    {userData.map(({ label, value }) => (
                        <ListItem divider key={label}>
                            <ListItemText
                                primary={
                                    (
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: value,
                                            }}
                                        />
                                    ) || '-'
                                }
                                secondary={label}
                            />
                        </ListItem>
                    ))}
                </List>
            </Grid>
        </ExternalScreen>
    );
}
